import { render, staticRenderFns } from "./AccountBoxList.vue?vue&type=template&id=78908d97&"
import script from "./AccountBoxList.vue?vue&type=script&lang=ts&"
export * from "./AccountBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBoxList.vue?vue&type=style&index=0&id=78908d97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports